import { render, staticRenderFns } from "./single-profile.vue?vue&type=template&id=00d5b7aa&"
import script from "./single-profile.vue?vue&type=script&lang=js&"
export * from "./single-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports